// GENERATED FILE - DO NOT MODIFY
export enum CallType {
    All = "T",
    Service = "S",
    Installation = "I",
    Maintenance = "M",
}

export let nameof = "CallType";
